import { DateTemplateInput } from 'types/graphql'

import DateTemplateInputs from 'src/components/DateTemplateInputs/DateTemplateInputs'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  field: TanstackField<Partial<DateTemplateInput>, TKey>
  isClearable?: boolean
  label?: React.ReactNode
}
const DateTemplateInputField = <TKey extends string>({
  caption,
  field,
  isClearable,
  label,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  return (
    <DateTemplateInputs
      caption={caption}
      dateTemplate={field.state.value}
      errorMessage={errorMessage}
      isClearable={isClearable}
      isInvalid={!!errorMessage}
      label={label}
      onChange={field.setValue}
    />
  )
}

export default DateTemplateInputField
